import { render, staticRenderFns } from "./ModeratorsListPopover.vue?vue&type=template&id=4c75621a&"
import script from "./ModeratorsListPopover.vue?vue&type=script&lang=js&"
export * from "./ModeratorsListPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports